import { Parser } from "json2csv";
import Priority_High from "../../../icons/priority_high.svg";
import Priority_Low from "../../../icons/priority_low.svg";
import Priority_Medium from "../../../icons/priority_medium.svg";
import Priority_Urgent from "../../../icons/priority_urgent.svg";
import { isJsonString } from "../../../lib/validation";
import { GetFindingTableResponse } from "../../tanstackQuery/queries/findings/type";

export const priorityBadge = (rating) => {
  let label = "",
    color = "",
    icon = "";
  if (rating === 5) {
    (label = "Critical"), (color = "#C14540"), (icon = Priority_Urgent);
  } else if (rating === 4) {
    (label = "High"), (color = "#F45567"), (icon = Priority_High);
  } else if (rating === 3) {
    (label = "Medium"), (color = "#FE911F"), (icon = Priority_Medium);
  } else if (rating === 2 || rating === 1) {
    (label = "Low"), (color = "#F9CF45"), (icon = Priority_Low);
  }
  return { label, color, icon };
};

export const getQuote = (_quote: string | any) => {
  const quote = isJsonString(_quote) ? JSON.parse(_quote)?.textCache : _quote;
  return quote;
};

export const getQuoteDescription = (_quote: string | any) => {
  const quote = isJsonString(_quote) ? JSON.parse(_quote)?.description : _quote;
  return quote;
};

function domDownload(filename, text) {
  var element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/csv;charset=utf-8," + encodeURIComponent(text)
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document?.body?.removeChild(element);
}

const getInsightType = (tags: GetFindingTableResponse["tags"]) => {
  if (!tags?.length) return "";
  const insightTypes = tags.map((tag) => tag.label);
  return insightTypes.join(", ");
};

const getLinks = (links: GetFindingTableResponse["links"]) => {
  if (!links?.length) return "";
  const linkCategories: string[] = [];
  links.forEach((link) => {
    const categoryName = link?.category?.name;
    if (categoryName) linkCategories.push(categoryName);
  });
  return linkCategories.join(", ");
};

const ratingValues = {
  5: "Critical",
  4: "High",
  3: "Medium",
  2: "Low",
  1: "Low"
};

export function handleExport(tableData: GetFindingTableResponse[]) {
  try {
    const data = tableData?.map((item) => ({
      date: item?.created?.split(" ").slice(0, 4).join(" "),
      interviewee: item?.interviewee,
      comment: item?.comment,
      quote: getQuote(item?.quote),
      insightType: getInsightType(item?.tags),
      links: getLinks(item?.links),
      rating: item?.rating?.global?.rating
        ? ratingValues[item?.rating?.global?.rating]
        : ""
    }));

    const fields = Object.keys(data[0]);
    const opts = { fields };
    const _parser = new Parser(opts);
    const _csv = _parser.parse(data);
    domDownload(
      `Discovery Data Export - ${new Date().toISOString()}.csv`,
      _csv
    );
  } catch (e) {
    console.log(e);
  }
}
